import {
  TypeProduct_cardWithoutUnresolvableLinksResponse
} from "@2u-landing-pages/types";

export type FilterBarProps = {
  programs?: TypeProduct_cardWithoutUnresolvableLinksResponse[];
  filteredPrograms?: TypeProduct_cardWithoutUnresolvableLinksResponse[];
  filters: any;
  setFilters: Function;
  numResults: number;
  filterGroups?: string[];
  filterLabels?: FilterLabels;
  showOptionTotals?: boolean;
  noRecommendedCard?: boolean;
  variation?: string;
  backgroundColor?: string;
};

export type FilterOption = {
  name: string;
  value: string;
  total: number;
};

export type FilterLabels = {
  [key: string]: string;
};

export type FilterCfg = {
  [key: string]: FilterOption[];
};

export const filterKeyMap = {
  School: "school_name",
  Topic: "topic",
  "Degree Level": "degree_level",
  Industry: "industry",
  Duration: "duration",
  "Tuition Cost": "tuition_cost",
  "Weekly Commitment": "weekly_commitment",
  "Start Date": "start_date",
};
